export default function getParamsUri<T>(location: string): T | null {
  if (location) {
    return JSON.parse(
      `{"${decodeURI(location.replace('?', ''))
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')}"}`,
    );
  }

  return null;
}
